import React, { useState, useEffect } from 'react';
import * as style from './Logo.module.scss';
import { useStateValue } from '../../context/Context';
import { maxHeightTransition } from '../../consts/transitions';

export default function Logo() {
  const [{ openSection }] = useStateValue();
  const [logoHeight, setLogoHeight] = useState('0px');

  useEffect(() => {
    setLogoHeight(() => {
      switch (openSection) {
        case 'Home':
          return '30vh';
        case 'About':
          return 'var(--logo-md)';
        case 'Artists':
          return 'var(--logo-sm)';
        case 'Tours':
          return 'var(--logo-sm)';
        case 'Get In Touch':
          return 'var(--logo-md)';
        default:
          return '30vh';
      }
    });
  }, [openSection]);

  return (
    <>
      <header className={style.logo}>
        <img
          className={style.svg}
          alt="Tangle Agency logo"
          src="/images/logos/PNG/tangle-logo-updated.png"
        />
      </header>
    </>
  );
}
